"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getZone = getZone;
exports.setActiveZone = setActiveZone;
exports.setZoneList = setZoneList;
exports.actionSetZoneList = exports.actionUpdateZoneList = exports.actionSetActiveZone = void 0;

var _sort = require("../../../helpers/sort");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var actionSetZone = function actionSetZone(zone) {
  return {
    payload: zone,
    type: 'SET_ZONE'
  };
};

var actionSetActiveZone = function actionSetActiveZone(zoneId) {
  return {
    payload: zoneId,
    type: 'SET_ACTIVE_ZONE'
  };
};

exports.actionSetActiveZone = actionSetActiveZone;

var actionSetZoneList = function actionSetZoneList(zoneList) {
  return {
    payload: zoneList,
    type: 'SET_ZONE_LIST'
  };
};

exports.actionSetZoneList = actionSetZoneList;

var actionUpdateZoneList = function actionUpdateZoneList(zoneList) {
  return {
    payload: zoneList,
    type: 'UPDATE_ZONE_LIST'
  };
};

exports.actionUpdateZoneList = actionUpdateZoneList;

function getZone() {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(dispatch, getState, _ref) {
        var zoneApi, _ref3, data, errors;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                zoneApi = _ref.zoneApi;
                _context.next = 3;
                return zoneApi.getZone();

              case 3:
                _ref3 = _context.sent;
                data = _ref3.data;
                errors = _ref3.errors;

                // const {data, errors} = {data: {name: 'Hello world'}};
                if (!errors) {
                  dispatch(actionSetZone(data));
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

function setZoneList(zoneList) {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(dispatch) {
        var idList;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                idList = (0, _sort.sortKeysByOrder)(zoneList);
                dispatch(actionSetZoneList({
                  data: zoneList,
                  list: idList
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
}

function setActiveZone(zoneId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(dispatch) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dispatch(actionSetActiveZone(zoneId));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x5) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
}